<template>
  <v-form @submit.prevent="createCrmUsers">
    <v-container>
      <v-row>
        <v-col md="12">
          <v-alert :value="true" color="grey lighten-2" class="grey--text">
            Select the users from below autocomplete field in order to add the
            users as CRM users.
          </v-alert>
        </v-col>
        <v-col :class="crmUsersObjectData.length > 0 ? `md6` : `md12`"> </v-col>
        <v-col :class="crmUsersObjectData.length > 0 ? `md6` : `md12`">
          <v-row>
            <v-col
              v-for="(user, index) in crmUsersObjectData"
              :key="index"
              md="4"
              class="mb-2"
            >
              <vue-user :user="user"></vue-user>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="12">
          <v-divider class="my-2"></v-divider>
          <v-btn class="primary" type="submit">
            Save
          </v-btn>
          <v-btn type="reset">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
export default {
  props: {
    formStatus: {
      type: Boolean,
      required: true
    },
    orgSlug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedCrmUsers: [],
      crmUsersObjectData: [],
      queryParams: {
        organization: this.orgSlug
      }
    };
  },
  watch: {
    formStatus(val) {
      if (!val) {
        this.selectedCrmUsers = [];
        this.crmUsersObjectData = [];
      }
    }
  },
  methods: {
    async createCrmUsers() {
      const postURL = "/api/v1/crm/users/bulk_create/";
      const formValues = {
        users: this.selectedCrmUsers,
        organization: this.orgSlug
      };
      this.$axios
        .$post(postURL, formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `CRM users were successfully added.`,
            color: "green"
          });
          this.$emit("crmUserFormResponse");
        })
        .catch(error => {
          // this.notifyInvalidFormResponse();
          return error;
        });
    }
  }
};
</script>
